import { Stack } from "@mui/material";
import { useGetCoherenceScoreOverTime, useGetRolesForUser, useGetUserStatistics } from "src/http";
import { StatisticsCard, StatisticWithGraph } from "src/components";
import { useBreakpoints } from "src/hooks";
import { useUserPageLayoutContext } from "src/pages";

const UserStatisticsSummary = () => {
  const { isMdUp } = useBreakpoints();
  const { user } = useUserPageLayoutContext();
  const { data: roles, isLoading: isLoadingRoles } = useGetRolesForUser(user.userId);
  const primaryRole = roles?.find((r) => r.isPrimaryRole);
  const { isLoading: isLoadingCoherenceData, data: coherenceScoreData } = useGetCoherenceScoreOverTime(
    primaryRole ? [primaryRole.parentTeam.guid] : undefined,
    undefined,
    12,
  );
  const { isLoading: isLoadingStatistics, data: userStatistics } = useGetUserStatistics(user.userId);

  return (
    <Stack direction={"row"} spacing={isMdUp ? 1 : 0.5}>
      <StatisticsCard
        isLoading={isLoadingCoherenceData || isLoadingRoles}
        data={[
          {
            title: "Home Team \nCoherence",
            sx: { flex: 1 },
            render: (
              <StatisticWithGraph
                isLoading={isLoadingCoherenceData}
                data={coherenceScoreData?.selectedTeamsCoherenceScores.map((x) => ({
                  dateUtc: x.dateUtc,
                  value: x.coherenceScore,
                }))}
                minYValue={0}
                maxYValue={10}
                formatValue={(value) => value.toFixed(2)}
              />
            ),
          },
        ]}
      />
      <StatisticsCard
        isLoading={isLoadingStatistics}
        sx={{ flex: 1 }}
        data={[
          {
            title: "Owned Active \nStrategic Items",
            value: userStatistics?.ownedActiveActionItemCount ?? 0,
          },
          {
            title: "Active \nTasks",
            value: userStatistics?.activeTaskItemCount ?? 0,
          },
          {
            title: "Active \nLoops",
            value: userStatistics?.activeIssueCount ?? 0,
          },
          {
            title: "Reporting \nMetrics",
            value: userStatistics?.reportingMetricCount ?? 0,
          },
        ]}
      />
    </Stack>
  );
};

export { UserStatisticsSummary };
